<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Equipe Comercial</h3>
        <a class="btn btn-success text-white float-right " @click="newMember" >Novo membro</a>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Equipes Comerciais Ativas</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <commercial-table :commercials="commercialTeams.list" />
            </div>
            <pagination :total-items="commercialTeams.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import CommercialTable from '../components/CommercialListTable.vue';
import { _EDIT_COMMERCIAL_, MODEL } from '../components/CommercialModel';

export default {
  name: 'commercial-team-list',
  components: {
    Pagination,
    CommercialTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    commercialTeams() {
      const { commercialList } = this.$store.state.commercial;
      if (commercialList && commercialList.list.length) {
        return commercialList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'getCommercialList',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getCommercialList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    newMember() {
      this.setToggle({ type: 'edit_commercial_modal', bool: true });
      Events.$emit(_EDIT_COMMERCIAL_, MODEL);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
